import { Injectable } from '@angular/core';
import { NetworkService } from '@damofire/data-angular-commons';
import { IndexedService, TEXTS_STORE } from '@damofire/data-commons';
import { LayoutTextSegment } from '../../warehouse/warehouse.dto';
import { RemoteService } from './remote.service';
import { FirebaseWarehouseLayoutTextService } from '../../layout/firebase-warehouse-layout-text.service';

@Injectable()
export class LayoutTextRemoteService extends RemoteService<LayoutTextSegment> {
  constructor(
    protected readonly idbService: IndexedService,
    protected readonly networkService: NetworkService,
    private readonly firebaseWarehouseService: FirebaseWarehouseLayoutTextService,
  ) {
    super(TEXTS_STORE, idbService, networkService);
  }

  async add(division: string, data: LayoutTextSegment[]): Promise<void> {
    await this.firebaseWarehouseService.create(division, data);
  }

  async delete(division: string, data: LayoutTextSegment[]): Promise<void> {
    await this.firebaseWarehouseService.delete(division, data);
  }

  async update(division: string, data: LayoutTextSegment[]): Promise<void> {
    await this.firebaseWarehouseService.update(division, data);
  }
}
